import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import {
  FormControlLabel,
  Checkbox,
  FormGroup,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import axios from "../../../../lib/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import axiosInstance from "../../../../lib/axios";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";
import { useReactToPrint } from "react-to-print";
import { getFormMode } from "../../../../lib/helpers";
import { z } from "zod"; 
import VendorAllocationModal from "./VendorAllocationModal";

const FORM_MODE = getFormMode();

const categoryFormSchema = z.object({
  TktCategoryName: z.string().min(1, "category is required"),
  Abrv: z.string().optional(),
  Remark: z.string().optional(),
  Status: z.enum(["1", "0"]).optional(),
});
const FORM_INIT_STATE = {
  TktCategoryName: "",
  Abrv: "",
  Remark: "",
  Status: FORM_MODE.add ? "1" : "0",
};

const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "TktCategoryName", label: "CategoryName", minWidth: 100 },
  { id: "Abrv", label: "Abrv", minWidth: 100 },
  { id: "Remark", label: "Remark", minWidth: 100 },
  { id: "Status", label: "Status", minWidth: 50 },
];

const TicketCategory = () => {
  const [formData, setFormData] = useState(FORM_INIT_STATE);
  const navigate = useNavigate();
  const [UserId, setUserId] = useState(sessionStorage.getItem("UserId"));
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [location, setLocation] = useState(useLocation());
  const [vendor, setVendor] = useState([]);
  const [Status, setStatus] = useState("1");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const [selectedVendorIds, setSelectedVendorIds] = useState([]);

  const [isVendorModalOpen, setIsVendorModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [currentTktCategoryId, setCurrentTktCategoryId] = useState(() => {
    if (location.state && location.state?.TktCategoryId) {
      return location.state && location.state?.TktCategoryId;
    }
    return undefined;
  });
  const [mode, setMode] = useState(() =>
    currentTktCategoryId ? FORM_MODE.read : FORM_MODE.add
  );

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState({
    isOpen: false,
    payload: null,
  });

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const tktCategoryNameRef = useRef(null);
  const abrvRef = useRef(null);
  const remarkRef = useRef(null);

  const [showAll, setShowAll] = useState(false);

  const handleToggleShowAll = () => {
    setShowAll((prev) => !prev);
  };

  useEffect(() => {
    const getRow = async () => {
      try {
        const res = await axiosInstance.post('TktCategory/getTktCategoryDashBoard', {
          start: 1,
          PageSize: 1,
          SearchText: "",
        });
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  useEffect(() => {
    if (location.state && location.state.TktCategoryId) {
      setCurrentTktCategoryId(location.state.TktCategoryId);
      fetchTktCategoryData(location.state.TktCategoryId);
      setMode(FORM_MODE.read);
    } else {
      setMode(FORM_MODE.add);
      setIsFormDisabled(false);
    }
  }, [location]);

  useEffect(() => {
    fetchVendors(currentTktCategoryId);
  }, []);

  const fetchVendors = async () => {
    try {
      const response = await axios.post(
        `TktCategory/GetMstPropWiseServProDashBoard`,
        { PropId: 1, WardenId: 1, ServiceProvId: 1, TktCategoryId: 1, Flag: "" }
      );
      const { data: { Status, Data } } = response;

      if (Status === 0 && Array.isArray(Data)) {
        setVendor(Data);
      } else {
        console.error("Failed to fetch vendors");
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  useEffect(() => {
    if (currentTktCategoryId) {
      fetchRetriveVendors(currentTktCategoryId);
    }
  }, []);
  // category wise vendors i mean checked 
  const fetchRetriveVendors = async (id) => {
    try {
      const response = await axiosInstance.post(
        `TktCategory/GetMstPropWiseServProDashBoard`,
        { PropId: 1, WardenId: 1, ServiceProvId: 1, TktCategoryId: id, Flag: "Cat" }
      );
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const vendorData = response.data.Data;

        if (Array.isArray(vendorData) && vendorData.length > 0) {
          const vendorIds = vendorData.map((vendor) => vendor.ServiceProvId);
          setSelectedVendorIds(vendorIds);
        } else {
          setSelectedVendorIds([]);
        }
      } else {
        setSelectedVendorIds([]);
      }
    } catch (error) {
      console.error("Error fetching Vendors:", error);
    }
  };

  const fetchTktCategoryData = async (id, flag) => {
    try {
      const response = await axiosInstance.post(
        `TktCategory/RetriveTktCategory`,
        {
          TktCategoryId: parseInt(id),
          Flag: flag,
        }
      );
      const {
        data: { Status, Data },
      } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setFormData({
          TktCategoryName: Data[0].TktCategoryName,
          Abrv: Data[0].Abrv,
          Remark: Data[0].Remark,
          Status: Data[0].Status,
        });
        setStatus(Data[0].Status.toString());
        setIsFormDisabled(true);
        setCurrentTktCategoryId(Data[0].TktCategoryId);
        return Data[0].TktCategoryId;
      }
    } catch (error) {
      console.error("Error fetching ticket category", error);
    }
  };

  const handlePrevious = async () => {
    if (currentTktCategoryId && currentTktCategoryId > 1) {
      const newTktCategoryId = await fetchTktCategoryData(currentTktCategoryId, "P");
      if (newTktCategoryId) {
        await fetchRetriveVendors(newTktCategoryId);
      }
    }
  };

  const handleNext = async () => {
    if (currentTktCategoryId) {
      const newTktCategoryId = await fetchTktCategoryData(currentTktCategoryId, "N");
      if (newTktCategoryId) {
        await fetchRetriveVendors(newTktCategoryId);
      }
    }
  };

  const handleEdit = () => {
    setMode(FORM_MODE.edit);
    setIsFormDisabled(false);
  };

  const handleAdd = () => {
    setMode(FORM_MODE.add);
    setIsFormDisabled(false);
    setFormData({
      TktCategoryName: "",
      Abrv: "",
      Remark: "",
      Status: "1",
    });
    setCurrentTktCategoryId(null);
    setSelectedVendorIds([]);
  };

  const handleExit = () => {
    navigate("/ticket-category-table", { replace: true });
  };

  const handleDelete = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      const response = await axiosInstance.post(
        `TktCategory/RetriveTktCategory`,
        {
          TktCategoryId: currentTktCategoryId,
          Flag: "D",
        }
      );
      const {
        data: { Status, Message, Data },
      } = response;
      if (Status === 0) {
        toast.success(Message, { autoClose: 1000 });
        await fetchTktCategoryData(currentTktCategoryId, "N");
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 1000 });
        } else {
          toast.error(Message, { autoClose: 1000 });
        }
      }

      await fetchTktCategoryData(currentTktCategoryId, "N");
      setMode(FORM_MODE.read);
      setIsFormDisabled(true);
    } catch (error) {
      return error;
    }
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    if (newSelectAll) {
      setSelectedVendorIds(vendor.map((item) => item.ServiceProvId));
    } else {
      setSelectedVendorIds([]);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedVendorIds((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((vendorId) => vendorId !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
    setFormData((prevState) => ({
      ...prevState,
      Status: updatedStatus,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.target === tktCategoryNameRef.current) {
        abrvRef.current.focus();
      } else if (event.target === abrvRef.current) {
        remarkRef.current.focus();
      } else {
        remarkRef.current.focus();
      }
    }
  };

  const handleSubmit = async () => {
    const result = categoryFormSchema.safeParse(formData);
    if (!result.success) {
      toast.error("Please fill required details.");
      return;
    }
    const { data } = result;
    const payload = {
      TktCategoryName: data.TktCategoryName,
      Abrv: data.Abrv,
      Remark: data.Remark,
      Status: data.Status,
    };

    let response;
    try {
      if (mode === FORM_MODE.edit) {
        payload.TktCategoryId = currentTktCategoryId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axiosInstance.patch(
          `TktCategory/UpdateTktCategory`,
          payload
        );
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axiosInstance.post(
          `TktCategory/InsertTktCategory`,
          payload
        );
      }

      const {
        data: { Status, Data, Message },
      } = response;

      if (Status === 0 && Data) {
        toast.success(Message, { autoClose: 1000 });

        // const serviceProviderPayload = {
        //   PropWiseServProConfig: selectedVendorIds.map((id) => ({
        //     TktCategoryId: mode === FORM_MODE.add ? Data : currentTktCategoryId,
        //     ServiceProvId: id,
        //   })),
        // };
        // let jsonData = JSON.stringify(serviceProviderPayload);

        // jsonData = jsonData.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        // jsonData = '"' + jsonData + '"';
        // await axiosInstance.post(
        //   `/TktCategory/ManageMstPropWiseServPro`,
        //   jsonData
        // );

        if (mode === FORM_MODE.add) {
          await fetchTktCategoryData(Data);
          setMode(FORM_MODE.read);
          setIsFormDisabled(true);
          setCurrentTktCategoryId(Data);
        } else {
          setMode(FORM_MODE.read);
        }
        setIsFormDisabled(true);
      }
    } catch (error) {
      console.error("Error during submit:", error);
    }
  };

  const handleCancel = async () => {
    if (mode === FORM_MODE.add) {
      try {
        await fetchTktCategoryData(1, "L");
        setMode(FORM_MODE.read);
        setIsFormDisabled(true);
      } catch (error) {
        toast.error('Error occurred while cancelling. Please try again.');
      }
    } else if (mode === FORM_MODE.edit) {
      if (currentTktCategoryId) {
        await fetchTktCategoryData(currentTktCategoryId, "R");
      }
      setMode(FORM_MODE.read);
      setIsFormDisabled(true);
    }
  };

  const handleNavigateLink = () => {
    navigate("/catwise-servprov-table");
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleOpenVendorModal = () => {
    setShowAll(false);
    setIsVendorModalOpen(true);
  };

  const handleCloseVendorModal = () => {
    setSearchTerm("");
    setIsVendorModalOpen(false);
  };

  return (
    <>
      <Box
        className="form-container"
        sx={{
          width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
          maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
          overflowX: "hidden",
          overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
        }}
      >
        <ToastContainer />
        <Grid
          container
          spacing={2}
          sx={{
            width: { xs: "93%", sm: "80%", md: "80%" },
            height: { xs: "460px", sm: "auto", md: "auto" },
            margin: "auto",
            marginTop: { xs: "60px", sm: 0, md: "auto" },
            marginBottom: { xs: "110px", sm: 0, md: "auto" },
            borderRadius: "8px",
            padding: { xs: "0px 5px 5px 5px", sm: "0px 20px 20px 20px" },
            backgroundColor: "#fff",
          }}
        >
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "30px",
              marginInline: { xs: "0px", sm: "2px", md: "20px" },
              flexDirection: { xs: "column", sm: "row", md: "row" },
              overflow: "hidden",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                className="three-d-button-previous"
                onClick={handlePrevious}
                sx={{
                  backgroundColor: "#635BFF",
                  marginRight: { xs: "0px", sm: "10px" },
                  display: "block",
                }}
                disabled={
                  mode !== FORM_MODE.read ||
                  !currentTktCategoryId ||
                  currentTktCategoryId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                className="three-d-button-next"
                onClick={handleNext}
                sx={{
                  backgroundColor: "#635BFF",
                  display: "block",
                }}
                disabled={mode !== FORM_MODE.read || !currentTktCategoryId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography
              variant="h5"
              sx={{
                margin: "auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "22px", sm: "18px", md: "24px" },
              }}
            >
              Ticket Category Master
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Ticket Category"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onView={handlePrint}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === FORM_MODE.read}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              mx: "auto",
            }}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: "800px", width: "100%" }}
            >
              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <TextField
                      id="TktCategoryName"
                      name="TktCategoryName"
                      label={
                        <span>
                          Ticket Category <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.TktCategoryName}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                      inputRef={tktCategoryNameRef}
                      onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <TextField
                      id="Abrv"
                      name="Abrv"
                      label="Abrv"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.Abrv}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                      inputRef={abrvRef}
                      onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <TextField
                      fullWidth
                      label="Remark"
                      name="Remark"
                      value={formData.Remark}
                      onChange={handleInputChange}
                      variant="filled"
                      disabled={mode === FORM_MODE.read}
                      className="custom-textfield"
                      inputRef={remarkRef}
                      onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={8}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  gap={0.1}
                  wrap={{ xs: "wrap", md: "nowrap" }}
                >
                  <FormGroup sx={{ flexShrink: 0 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={mode === FORM_MODE.read}
                          checked={Status === "1"}
                          onChange={handleChangeStatus}
                        />
                      }
                      label="Status"
                    />
                  </FormGroup>
                  <Button
                    variant="contained"
                    onClick={handleOpenVendorModal}
                   disabled={mode === FORM_MODE.read || mode === FORM_MODE.add}
                    sx={{
                      paddingBlock: 0.5,
                      paddingInline: 1,
                      color: "white",
                      backgroundColor:
                        mode === FORM_MODE.read ? "#e0e0e0ed" : "#635bff",
                      "&:hover": {
                        backgroundColor:
                          mode === FORM_MODE.read ? "#e0e0e0" : "#635bff",
                      },
                      minWidth: { xs: "100px", sm: "150px" },
                      flexShrink: 1,
                    }}
                  >
                    Allocate Vendors
                  </Button>
                </Grid>
              </Grid>
              {/* <VendorAllocationModal
                open={isVendorModalOpen}
                onClose={handleCloseVendorModal}
                vendors={vendor}
                searchTerm={searchTerm}
                onSearchChange={setSearchTerm}
                selectedVendorIds={selectedVendorIds}
                onToggleVendor={handleCheckboxChange}
                isReadOnly={mode === FORM_MODE.read}
                showAll={showAll}
                onToggleShowAll={handleToggleShowAll}
                formData={formData} 
              /> */}
              <VendorAllocationModal
                open={isVendorModalOpen}
                onClose={handleCloseVendorModal}
                vendors={vendor}
                searchTerm={searchTerm}
                onSearchChange={setSearchTerm}
                selectedVendorIds={selectedVendorIds}
                onToggleVendor={handleCheckboxChange}
                isReadOnly={mode === FORM_MODE.read}
                showAll={showAll}
                onToggleShowAll={handleToggleShowAll}
                formData={formData}
                currentTktCategoryId={currentTktCategoryId}   // NEW
                setSelectedVendorIds={setSelectedVendorIds}
                fetchRetriveVendors={fetchRetriveVendors}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            className="form_button"
            sx={{ marginBottom: "10px", marginInline: "20px" }}
          >
            {mode === FORM_MODE.read && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                    "@media (max-width: 600px)": {
                      padding: "0px 0px !important",
                    },
                  }}
                  onClick={handleSubmit}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                    "@media (max-width: 600px)": {
                      padding: "0px 0px !important",
                    },
                  }}
                  onClick={handleCancel}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    "@media (max-width: 600px)": {
                      padding: "0px 0px !important",
                    },
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    "@media (max-width: 600px)": {
                      padding: "0px 0px !important",
                    },
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>

        <div style={{ display: "none" }}>
          {rows.length > 0 && (
            <ReportTable
              columns={columns}
              rows={rows.map(row => ({
                ...row,
                Status: row.Status === "1" ? "Active" : row.Status === "0" ? "Inactive" : row.Status,
              }))}
              title="Ticket Category Master"
              contentRef={contentRef}
              customStyles={{ backgroundColor: "#f5f5f5" }}
            />
          )}
        </div>
        <Dialog
          open={openConfirmDialog}
          onClose={handleCloseConfirmDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
              onClick={handleConfirmDelete}
            >
              Yes
            </Button>
            <Button
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
              onClick={handleCloseConfirmDialog}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
      </Box> {/* Added closing Box tag */}
    </>
  );
};

export default TicketCategory;